<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-overlay :show="loadingKitType" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">TIPOS DE KITS</h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'kit_type')"
              class="btn-add"
              v-on:click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>

          <!-- Modal create -->
          <b-modal no-close-on-backdrop id="createKitType" hide-footer>
            <template v-slot:modal-title>NOVO TIPO DE KIT</template>
            <form v-on:submit="create" method="post">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <LabelRequiredField label="Nome" />
                <input
                  type="text"
                  ref="autofocus"
                  v-model="name"
                  class="form-control"
                />
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
              </div>
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  text-right
                "
              >
                <v-btn :disabled="loadingCreate" type="submit" class="btn-save">
                  <i class="fas fa-save mr-2 text-twenty"></i>
                  {{ loadingCreate ? "Carregando" : "SALVAR" }}
                </v-btn>
              </div>
            </form>
          </b-modal>
          <!-- /Modal create -->

          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-12 pt-0 pb-1">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="kitTypes.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="kitTypes.length > 0"
          dense
          :headers="headers"
          :items="kitTypes"
          :search="search"
          sort-by="name"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.name`]="{ item }">
            <!-- Modal update kitType -->
            <b-modal
              no-close-on-backdrop
              :id="`kitType_${String(item.id)}`"
              hide-footer
            >
              <template v-slot:modal-title>EDITAR TIPO DE KIT</template>
              <b-overlay :show="loadingKitTypeUpdate" opacity="0.99">
                <form v-on:submit="update" method="post">
                  <WarningMessage
                    v-if="!permission('edit', 'kit_type')"
                    message="Você não tem permissão para modificar tipos de kit"
                  />

                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <LabelRequiredField label="Nome" />
                    <input
                      :disabled="!permission('edit', 'kit_type')"
                      type="text"
                      ref="autofocus"
                      v-model="name"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
                  >
                    <WarningRequiredFields
                      v-if="permission('edit', 'kit_type')"
                    />
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <h6 class="mb-0 worksansr">
                      Criação:
                      {{ formatDate(item.created_at) }}
                    </h6>
                    <h6 class="mb-0 worksansr">
                      Última alteração:
                      {{ formatDate(item.updated_at) }}
                    </h6>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <confirmation-dialog
                      v-if="permission('remove', 'kit_type')"
                      message-title="CONFIRMAÇÃO"
                      message-body="Deseja realmente apagar a tipo de kit? Só pode apagar caso não exista vinculo da tipo de kit com kit de produto!"
                      open-left-icon="fa-trash"
                      open-class="btn-delete"
                      open-text="EXCLUIR"
                      @yes="deleteKitType(item)"
                    />
                    <v-btn
                      v-if="permission('edit', 'kit_type')"
                      :disabled="loadingUpdate"
                      type="submit"
                      class="btn-save float-right"
                    >
                      <i class="fas fa-save mr-2 text-twenty"></i>
                      {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                    </v-btn>
                  </div>
                </form>
              </b-overlay>
            </b-modal>
            <!-- /Modal update kitType -->
            {{ item.name }}
          </template>
        </v-data-table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";
import routes from "../routes";
import api from "../services/api";

import toast from "../lib/ToastNotification";

import { formatDate } from "../lib/format";
import { userData } from "../lib/functions";
import permission from "../lib/permission";

export default {
  name: "KitTypes",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
  },
  data() {
    return {
      user_id: "",
      search: "",
      headers: [{ text: "Nome", value: "name" }],
      rest_home_id: "",
      kitTypes: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingKitTypeUpdate: false,
      loadingKitType: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatDate,
    handleToBack: () => routes.go(-1),
    handleClickRowTable(item) {
      this.handleModalKitType(item.id);
      this.$bvModal.show(`kitType_${String(item.id)}`);
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },
    async retrieve() {
      this.rest_home_id = userData().user.rest_home_id;
      this.user_id = userData().user.id;

      await this.getKitTypes();
    },
    async getKitTypes(page = 1) {
      try {
        this.loadingKitType = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/rest-home/kit-type/paginate", {
          params,
        });

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.kitTypes = types;
        }
        this.loadingKitType = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { user_id, rest_home_id, name } = this;

        let params = { user_id, rest_home_id, name };

        const response = await api.post("/rest-home/kit-type/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createKitType");
          this.getKitTypes();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.name = "";
      this.errors = [];
      this.$bvModal.show("createKitType");
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { user_id, id, rest_home_id, name } = this;

        let params = { user_id, id, rest_home_id, name };

        const response = await api.put("/rest-home/kit-type/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`kitType_${String(id)}`);
          this.getKitTypes();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleModalKitType(id) {
      try {
        this.loadingKitTypeUpdate = true;
        this.errors = [];
        this.id = id;

        const { rest_home_id } = this;

        const response = await api.get("/rest-home/kit-type/get", {
          params: { id, rest_home_id },
        });

        const { error, errors, type } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.id = type.id;
          this.name = type.name;
        }
        this.loadingKitTypeUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteKitType(type) {
      try {
        const { user_id } = this;

        const { id, rest_home_id } = type;

        let data = { user_id, id, rest_home_id };

        const response = await api.delete("/rest-home/kit-type/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getKitTypes();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
